export const translations = {
  es: {
    nav: {
      about: "Nosotros",
      services: "Servicios",
      process: "Proceso",
      investment: "Inversión",
      contact: "Contacto",
    },
    hero: {
      tagline: "INVERSIÓN INMOBILIARIA EN PORTUGAL",
      title: "Tu socio estratégico de inversión en Madeira",
      subtitle: "Acceso prioritario a oportunidades inmobiliarias en Madeira, mayormente off-market: due diligence, adquisición, obra y salida. Tú eliges cuánto involucrarte.",
      cta: "Agendar Reunión",
      ctaSecondary: "Conocer Más",
    },
    about: {
      label: "SOBRE NOSOTROS",
      title: "Más de 16 años de experiencia en el mercado inmobiliario de Madeira",
      p1: "EDSTATE nació de algo raro en este sector: relaciones reales. Clientes que comenzaron con una compra guiada hoy son amigos y socios, y forman parte de nuestra comunidad privada de inversionistas.",
      p2Bold: "No somos inmobiliaria.",
      p2: "Somos una empresa de inversión, desarrollo y gestión estratégica. Identificamos activos con potencial, estructuramos la operación y ejecutamos con un estándar claro.",
      p3: "Nuestro objetivo no es intermediar ventas. Es maximizar el potencial real de cada oportunidad junto a inversionistas que priorizan claridad, protección de capital y retornos bien diseñados.",
      stat1: "16+",
      stat1Label: "Años de experiencia",
      stat2: "200+",
      stat2Label: "Agentes en red",
      stat3: "100%",
      stat3Label: "Gestión integral",
    },
    services: {
      label: "SERVICIOS",
      title: "¿Qué hacemos por ti?",
      s1Title: "Búsqueda de Oportunidades Únicas",
      s1Desc: "Detectamos inmuebles off-market con sistemas de prospección y red local. Llegamos directo al propietario y negociamos condiciones para cerrar oportunidades con mejor margen.",
      s2Title: "Análisis Técnico y Financiero",
      s2Desc: "Claridad total antes de avanzar: números de entrada, fiscalidad y rangos de inversión en reforma. Proyección de valor final y escenarios de retorno según diferentes salidas.",
      s3Title: "Gestión Operativa Integral",
      s3Desc: "Coordinación completa: arquitectura, ingeniería, licencias, supervisión de obras, regularización registral y gestión notarial.",
      s4Title: "Asesoría en Subastas",
      s4Desc: "Evaluación física y legal de inmuebles en subasta. Verificación de cargas registrales e inspección in situ de la propiedad.",
    },
    process: {
      label: "PROCESO",
      title: "De la oportunidad a la rentabilidad",
      step1: "Detección",
      step1Desc: "Acceso a propiedades de alto potencial antes de salir al mercado mediante prospección directa y nuestra red de agentes.",
      step2: "Análisis",
      step2Desc: "Estudio completo: documentación, legalidad, historial registral, cargas y limitaciones. Evaluación del valor real.",
      step3: "Presentación",
      step3Desc: "Si la operación cumple nuestros criterios, se muestra de forma privada a nuestra red de inversionistas.",
      step4: "Negociación",
      step4Desc: "Negociación directa con propietarios sin intermediarios para conseguir mejores precios de compra.",
      step5: "Ejecución",
      step5Desc: "Selección de arquitectos y constructoras. Supervisión completa de obra, calidad, presupuesto y cronograma.",
      step6: "Legalización",
      step6Desc: "Licencias, documentación técnica, permisos, registro. Todo en regla para la venta.",
      step7: "Comercialización",
      step7Desc: "Producción de marketing profesional. Venta a través de nuestra red de agentes y portales premium.",
    },
    investment: {
      label: "MODELOS DE INVERSIÓN",
      title: "Dos formas de invertir. Un mismo estándar.",
      subtitle: "Elige el nivel de participación que mejor se adapte a ti. Nosotros nos encargamos del resto.",
      model1: "Gestión Integral EDSTATE",
      model1Desc: "Para el inversor que prefiere delegar por completo",
      model1Features: [
        "Identificación y análisis de oportunidades off-market",
        "Negociación, adquisición y gestión documental completa",
        "Coordinación de obra, supervisión y control de calidad",
        "Estrategia de salida y comercialización profesional",
        "Reporting periódico sin necesidad de seguimiento activo"
      ],
      model2: "Gestión Compartida",
      model2Desc: "Para el inversor que quiere participar en decisiones clave",
      model2Features: [
        "Acceso a las mismas oportunidades y análisis detallado",
        "Tú supervisas la obra o eliges proveedores de confianza",
        "Nosotros gestionamos la estrategia y la salida",
        "Mayor control operativo con apoyo experto",
        "Comunicación directa en cada fase del proyecto"
      ],
      slider1Label: "Participación del inversor",
      slider1Left: "Mínima",
      slider1Right: "Activa",
      slider2Label: "Ejecución EDSTATE",
      slider2Left: "Coordinación",
      slider2Right: "Integral",
      slider3Label: "Tiempo requerido",
      slider3Left: "Bajo",
      slider3Right: "Moderado",
      ctaTitle: "¿Quieres conocer los detalles exactos?",
      ctaText: "Al contactarnos, te enviamos un PDF privado con porcentajes, estructura de fees, ejemplos reales y escenarios de retorno según cada modelo.",
      ctaButton: "Solicitar PDF Privado",
      ctaConfidential: "Compartimos los detalles por privado para mantener claridad y discreción.",
    },
    benefits: {
      label: "BENEFICIOS",
      title: "¿Por qué invertir con EDSTATE?",
      b1: "Acceso a oportunidades reales y mayormente inéditas",
      b2: "Costes reducidos por negociación directa con propietarios",
      b3: "Supervisión total de obras, documentación y procesos legales",
      b4: "Amplia red de comercialización internacional",
      b5: "Transparencia, compromiso y foco absoluto en la rentabilidad",
      b6: "Comisiones reducidas al 4% (en lugar de 5-6%)",
    },
    security: {
      label: "SEGURIDAD LEGAL",
      title: "Tu inversión protegida desde el primer momento",
      subtitle: "Cada operación se estructura para que estés cubierto legal y fiscalmente desde el inicio.",
      s1Title: "Estructura Legal del Inversor",
      s1Desc: "Entras con una posición legal definida y protección real sobre tu capital desde el día uno.",
      s2Title: "Acompañamiento Legal",
      s2Desc: "Abogados y notarios locales supervisan cada paso. Cumplimiento normativo garantizado.",
      s3Title: "Contratos y Responsabilidades",
      s3Desc: "Acuerdos firmados con roles, derechos y obligaciones claras para todas las partes.",
      s4Title: "Documentación y Transparencia",
      s4Desc: "Acceso completo a registros, informes y trazabilidad de cada movimiento.",
      checkpoint1: "Estructura",
      checkpoint2: "Legal",
      checkpoint3: "Contratos",
      checkpoint4: "Documentación",
    },
    contact: {
      label: "CONTACTO",
      title: "¿Te gustaría formar parte de nuestros próximos proyectos?",
      subtitle: "Contáctanos para recibir las oportunidades actuales y agendar una reunión privada donde podremos presentarte las estrategias de inversión, detalles operativos y proyecciones de beneficio.",
      name: "Nombre completo",
      email: "Correo electrónico",
      phone: "Teléfono",
      message: "Mensaje",
      messagePlaceholder: "Cuéntanos sobre tu interés en invertir...",
      submit: "Enviar Mensaje",
      sending: "Enviando...",
      success: "¡Mensaje enviado! Nos pondremos en contacto contigo pronto.",
      error: "Error al enviar. Por favor, intenta de nuevo.",
      consent: "He leído y acepto la",
      consentLink: "Política de Privacidad",
      consentError: "Debes aceptar la Política de Privacidad para continuar.",
    },
    footer: {
      tagline: "Tu socio estratégico de inversión inmobiliaria en Portugal",
      rights: "Todos los derechos reservados",
      privacy: "Privacidad",
      terms: "Términos",
    },
    privacy: {
      title: "Política de Privacidad",
      lastUpdate: "Última actualización",
      backButton: "Volver",
      sections: {
        intro: {
          title: "Introducción",
          content: "En EDSTATE Capital nos comprometemos a proteger tu privacidad y tus datos personales. Esta Política de Privacidad explica cómo recopilamos, utilizamos y protegemos la información que nos proporcionas a través de nuestro sitio web."
        },
        controller: {
          title: "Responsable del Tratamiento",
          content: "El responsable del tratamiento de tus datos personales es:",
          name: "Edson Rodrigues",
          location: "Funchal, Madeira, Portugal",
          email: "Email de contacto: info@edstatecapital.com"
        },
        dataCollected: {
          title: "Datos que Recopilamos",
          content: "Únicamente recopilamos los datos que nos proporcionas voluntariamente a través del formulario de contacto de nuestro sitio web:",
          items: [
            "Nombre completo",
            "Dirección de correo electrónico",
            "Número de teléfono (opcional)",
            "Mensaje o consulta",
            "Idioma de preferencia",
            "Fecha y hora del envío"
          ],
          note: "No utilizamos cookies de seguimiento, analytics ni herramientas de tracking de terceros (como Google Analytics, Meta Pixel o similares)."
        },
        purpose: {
          title: "Finalidad del Tratamiento",
          content: "Utilizamos tus datos personales exclusivamente para:",
          items: [
            "Responder a tus consultas e inquietudes",
            "Coordinar reuniones y llamadas informativas",
            "Proporcionarte información sobre nuestros servicios de inversión inmobiliaria",
            "Gestionar la relación precontractual o contractual si decides trabajar con nosotros"
          ]
        },
        legalBasis: {
          title: "Base Legal",
          content: "El tratamiento de tus datos se basa en:",
          items: [
            "Tu consentimiento expreso al enviar el formulario de contacto",
            "La ejecución de medidas precontractuales cuando solicitas información sobre nuestros servicios",
            "Nuestro interés legítimo en responder a consultas comerciales"
          ]
        },
        retention: {
          title: "Conservación de Datos",
          content: "Conservamos tus datos personales durante los siguientes plazos:",
          items: [
            "Si no se establece relación comercial: 12 meses desde tu última comunicación",
            "Si se establece relación comercial: durante la vigencia de la relación y posteriormente el tiempo necesario para cumplir con obligaciones legales (hasta 6 años para obligaciones fiscales y contables)"
          ]
        },
        recipients: {
          title: "Destinatarios y Encargados del Tratamiento",
          content: "Para gestionar tus datos y responder a tus consultas, utilizamos los siguientes proveedores de servicios que actúan como encargados del tratamiento:",
          items: [
            "Resend: proveedor de servicios de email para el envío de comunicaciones",
            "Emergent: plataforma de hosting y alojamiento web",
            "MongoDB: base de datos para el almacenamiento seguro de registros"
          ],
          note: "Estos proveedores solo tratan tus datos siguiendo nuestras instrucciones y conforme a sus respectivas políticas de privacidad."
        },
        transfers: {
          title: "Transferencias Internacionales",
          content: "Algunos de nuestros proveedores de servicios pueden estar ubicados fuera del Espacio Económico Europeo. En estos casos, nos aseguramos de que existan salvaguardas adecuadas para proteger tus datos, como cláusulas contractuales tipo aprobadas por la Comisión Europea o la adhesión al Marco de Privacidad de Datos UE-EE.UU."
        },
        rights: {
          title: "Tus Derechos",
          content: "Conforme al Reglamento General de Protección de Datos (RGPD), tienes derecho a:",
          items: [
            "Acceso: conocer qué datos personales tratamos sobre ti",
            "Rectificación: corregir datos inexactos o incompletos",
            "Supresión: solicitar la eliminación de tus datos cuando ya no sean necesarios",
            "Oposición: oponerte al tratamiento de tus datos en determinadas circunstancias",
            "Limitación: solicitar la limitación del tratamiento en ciertos casos",
            "Portabilidad: recibir tus datos en un formato estructurado y de uso común",
            "Retirar el consentimiento: en cualquier momento, sin que ello afecte a la licitud del tratamiento anterior"
          ],
          exercise: "Para ejercer cualquiera de estos derechos, contacta con nosotros en: info@edstatecapital.com",
          complaint: "También tienes derecho a presentar una reclamación ante la autoridad de control competente: la Comissão Nacional de Proteção de Dados (CNPD) en Portugal."
        },
        security: {
          title: "Seguridad",
          content: "Implementamos medidas técnicas y organizativas razonables para proteger tus datos personales contra el acceso no autorizado, la pérdida, destrucción o alteración. Estas medidas incluyen el uso de conexiones cifradas (HTTPS) y el almacenamiento seguro de la información."
        },
        changes: {
          title: "Cambios en esta Política",
          content: "Podemos actualizar esta Política de Privacidad ocasionalmente. Cualquier cambio será publicado en esta página con la fecha de última actualización. Te recomendamos revisarla periódicamente."
        },
        contact: {
          title: "Contacto",
          content: "Si tienes cualquier pregunta sobre esta Política de Privacidad o sobre el tratamiento de tus datos personales, puedes contactarnos en:",
          email: "info@edstatecapital.com"
        }
      }
    },
    terms: {
      title: "Términos y Condiciones",
      lastUpdate: "Última actualización",
      backButton: "Volver",
      sections: {
        intro: {
          title: "Introducción",
          content: "Estos Términos y Condiciones regulan el acceso y uso del sitio web edstatecapital.com (en adelante, el \"Sitio Web\"), operado por Edson Rodrigues. Al acceder o utilizar este Sitio Web, aceptas estos términos en su totalidad."
        },
        purpose: {
          title: "Finalidad del Sitio Web",
          content: "Este Sitio Web tiene una finalidad exclusivamente informativa. Su objetivo es presentar los servicios de inversión inmobiliaria que ofrece EDSTATE Capital y facilitar el contacto con potenciales inversores interesados."
        },
        disclaimer: {
          title: "Exención de Responsabilidad",
          content: "La información contenida en este Sitio Web:",
          items: [
            "No constituye asesoramiento legal, fiscal, financiero ni de inversión",
            "No debe considerarse como una oferta o solicitud de compra de ningún activo o servicio financiero",
            "Es de carácter general y puede no adaptarse a tu situación particular"
          ],
          note: "Cualquier decisión de inversión debe ser evaluada de forma independiente y, si es necesario, con el asesoramiento de profesionales cualificados. Las inversiones inmobiliarias conllevan riesgos, incluyendo la posible pérdida de capital."
        },
        liability: {
          title: "Limitación de Responsabilidad",
          content: "EDSTATE Capital no será responsable de:",
          items: [
            "Daños directos o indirectos derivados del uso o imposibilidad de uso del Sitio Web",
            "Errores u omisiones en el contenido del Sitio Web",
            "Decisiones tomadas basándose en la información proporcionada en el Sitio Web",
            "Interrupciones, fallos técnicos o problemas de seguridad del Sitio Web",
            "Acciones de terceros que puedan afectar al Sitio Web o a sus usuarios"
          ]
        },
        ip: {
          title: "Propiedad Intelectual",
          content: "Todos los contenidos de este Sitio Web, incluyendo pero no limitado a textos, gráficos, logotipos, imágenes, diseño y código fuente, son propiedad de EDSTATE Capital o de sus respectivos titulares y están protegidos por las leyes de propiedad intelectual aplicables.",
          restrictions: "Queda prohibida la reproducción, distribución, modificación o uso comercial de cualquier contenido del Sitio Web sin autorización expresa por escrito."
        },
        links: {
          title: "Enlaces a Terceros",
          content: "Este Sitio Web puede contener enlaces a sitios web de terceros. Estos enlaces se proporcionan únicamente para tu comodidad. EDSTATE Capital no tiene control sobre el contenido de estos sitios y no asume ninguna responsabilidad por ellos ni por cualquier daño derivado de su uso."
        },
        modifications: {
          title: "Modificaciones",
          content: "Nos reservamos el derecho de modificar estos Términos y Condiciones en cualquier momento. Las modificaciones entrarán en vigor desde su publicación en el Sitio Web. El uso continuado del Sitio Web tras cualquier modificación implica la aceptación de los nuevos términos."
        },
        law: {
          title: "Ley Aplicable y Jurisdicción",
          content: "Estos Términos y Condiciones se rigen por la legislación portuguesa. Para cualquier controversia derivada del uso del Sitio Web, las partes se someten a la jurisdicción exclusiva de los tribunales de Portugal, con renuncia expresa a cualquier otro fuero que pudiera corresponderles."
        },
        contact: {
          title: "Contacto",
          content: "Si tienes cualquier pregunta sobre estos Términos y Condiciones, puedes contactarnos en:",
          email: "info@edstatecapital.com"
        }
      }
    },
    keepProperty: {
      label: "OPCIÓN DE CONSERVAR",
      title: "¿Prefieres quedarte con el inmueble?",
      desc: "Si tras la valorización decides conservar el proyecto, se aplicará el porcentaje acordado sobre la ganancia proyectada inicialmente. Transforma un proyecto de inversión en un activo personal, sin sorpresas, con la tranquilidad de haber adquirido por debajo del valor de mercado.",
    },
  },
  en: {
    nav: {
      about: "About",
      services: "Services",
      process: "Process",
      investment: "Investment",
      contact: "Contact",
    },
    hero: {
      tagline: "REAL ESTATE INVESTMENT IN PORTUGAL",
      title: "Your strategic investment partner in Madeira",
      subtitle: "Priority access to real estate opportunities in Madeira, mostly off-market: due diligence, acquisition, construction and exit. You choose how involved you want to be.",
      cta: "Schedule Meeting",
      ctaSecondary: "Learn More",
    },
    about: {
      label: "ABOUT US",
      title: "Over 16 years of experience in Madeira's real estate market",
      p1: "EDSTATE was born from something rare in this sector: real relationships. Clients who started with a guided purchase are now friends and partners, part of our private investor community.",
      p2Bold: "We are not a real estate agency.",
      p2: "We are an investment, development, and strategic management company. We identify assets with potential, structure the operation, and execute with a clear standard.",
      p3: "Our goal is not to intermediate sales. It's to maximize the real potential of each opportunity alongside investors who prioritize clarity, capital protection, and well-designed returns.",
      stat1: "16+",
      stat1Label: "Years of experience",
      stat2: "200+",
      stat2Label: "Network agents",
      stat3: "100%",
      stat3Label: "Comprehensive management",
    },
    services: {
      label: "SERVICES",
      title: "What do we do for you?",
      s1Title: "Unique Opportunity Sourcing",
      s1Desc: "We detect off-market properties with prospecting systems and local network. We go directly to the owner and negotiate conditions to close opportunities with better margins.",
      s2Title: "Technical and Financial Analysis",
      s2Desc: "Total clarity before moving forward: entry numbers, taxation and renovation investment ranges. Final value projection and return scenarios according to different exits.",
      s3Title: "Comprehensive Operational Management",
      s3Desc: "Complete coordination: architecture, engineering, licenses, work supervision, registry regularization and notarial management.",
      s4Title: "Auction Advisory",
      s4Desc: "Physical and legal evaluation of properties at auction. Verification of registry charges and on-site property inspection.",
    },
    process: {
      label: "PROCESS",
      title: "From opportunity to profitability",
      step1: "Detection",
      step1Desc: "Access to high-potential properties before market through direct prospecting and our agent network.",
      step2: "Analysis",
      step2Desc: "Complete study: documentation, legality, registry history, charges and limitations. Real value evaluation.",
      step3: "Presentation",
      step3Desc: "If the operation meets our criteria, it is shown privately to our investor network.",
      step4: "Negotiation",
      step4Desc: "Direct negotiation with owners without intermediaries to achieve better purchase prices.",
      step5: "Execution",
      step5Desc: "Selection of architects and construction companies. Complete supervision of work, quality, budget and schedule.",
      step6: "Legalization",
      step6Desc: "Licenses, technical documentation, permits, registration. Everything in order for sale.",
      step7: "Commercialization",
      step7Desc: "Professional marketing production. Sale through our agent network and premium portals.",
    },
    investment: {
      label: "INVESTMENT MODELS",
      title: "Two ways to invest. One standard.",
      subtitle: "Choose the level of participation that suits you best. We take care of the rest.",
      model1: "Full EDSTATE Management",
      model1Desc: "For the investor who prefers to delegate completely",
      model1Features: [
        "Identification and analysis of off-market opportunities",
        "Negotiation, acquisition and complete document management",
        "Construction coordination, supervision and quality control",
        "Exit strategy and professional commercialization",
        "Periodic reporting without need for active follow-up"
      ],
      model2: "Shared Management",
      model2Desc: "For the investor who wants to participate in key decisions",
      model2Features: [
        "Access to the same opportunities and detailed analysis",
        "You supervise the work or choose trusted providers",
        "We manage the strategy and exit",
        "Greater operational control with expert support",
        "Direct communication at each project phase"
      ],
      slider1Label: "Investor participation",
      slider1Left: "Minimal",
      slider1Right: "Active",
      slider2Label: "EDSTATE execution",
      slider2Left: "Coordination",
      slider2Right: "Integral",
      slider3Label: "Time required",
      slider3Left: "Low",
      slider3Right: "Moderate",
      ctaTitle: "Want to know the exact details?",
      ctaText: "When you contact us, we send you a private PDF with percentages, fee structure, real examples and return scenarios for each model.",
      ctaButton: "Request Private PDF",
      ctaConfidential: "We share details privately to maintain clarity and discretion.",
    },
    benefits: {
      label: "BENEFITS",
      title: "Why invest with EDSTATE?",
      b1: "Access to real and mostly unpublished opportunities",
      b2: "Reduced costs through direct negotiation with owners",
      b3: "Total supervision of works, documentation and legal processes",
      b4: "Extensive international commercialization network",
      b5: "Transparency, commitment and absolute focus on profitability",
      b6: "Reduced commissions at 4% (instead of 5-6%)",
    },
    security: {
      label: "LEGAL SECURITY",
      title: "Your investment protected from day one",
      subtitle: "Every operation is structured so you're legally and fiscally covered from the start.",
      s1Title: "Investor Legal Structure",
      s1Desc: "You enter with a defined legal position and real protection over your capital from day one.",
      s2Title: "Legal Accompaniment",
      s2Desc: "Local lawyers and notaries supervise every step. Regulatory compliance guaranteed.",
      s3Title: "Contracts and Responsibilities",
      s3Desc: "Signed agreements with clear roles, rights and obligations for all parties.",
      s4Title: "Documentation and Transparency",
      s4Desc: "Complete access to records, reports and traceability of every movement.",
      checkpoint1: "Structure",
      checkpoint2: "Legal",
      checkpoint3: "Contracts",
      checkpoint4: "Documentation",
    },
    contact: {
      label: "CONTACT",
      title: "Would you like to be part of our next projects?",
      subtitle: "Contact us to receive current opportunities and schedule a private meeting where we can present investment strategies, operational details and profit projections.",
      name: "Full name",
      email: "Email address",
      phone: "Phone",
      message: "Message",
      messagePlaceholder: "Tell us about your interest in investing...",
      submit: "Send Message",
      sending: "Sending...",
      success: "Message sent! We will contact you soon.",
      error: "Error sending. Please try again.",
      consent: "I have read and accept the",
      consentLink: "Privacy Policy",
      consentError: "You must accept the Privacy Policy to continue.",
    },
    footer: {
      tagline: "Your strategic real estate investment partner in Portugal",
      rights: "All rights reserved",
      privacy: "Privacy",
      terms: "Terms",
    },
    privacy: {
      title: "Privacy Policy",
      lastUpdate: "Last updated",
      backButton: "Back",
      sections: {
        intro: {
          title: "Introduction",
          content: "At EDSTATE Capital, we are committed to protecting your privacy and personal data. This Privacy Policy explains how we collect, use, and protect the information you provide to us through our website."
        },
        controller: {
          title: "Data Controller",
          content: "The data controller responsible for your personal data is:",
          name: "Edson Rodrigues",
          location: "Funchal, Madeira, Portugal",
          email: "Contact email: info@edstatecapital.com"
        },
        dataCollected: {
          title: "Data We Collect",
          content: "We only collect data that you voluntarily provide through the contact form on our website:",
          items: [
            "Full name",
            "Email address",
            "Phone number (optional)",
            "Message or inquiry",
            "Language preference",
            "Date and time of submission"
          ],
          note: "We do not use tracking cookies, analytics, or third-party tracking tools (such as Google Analytics, Meta Pixel, or similar)."
        },
        purpose: {
          title: "Purpose of Processing",
          content: "We use your personal data exclusively to:",
          items: [
            "Respond to your inquiries and questions",
            "Schedule meetings and informational calls",
            "Provide you with information about our real estate investment services",
            "Manage the pre-contractual or contractual relationship if you decide to work with us"
          ]
        },
        legalBasis: {
          title: "Legal Basis",
          content: "The processing of your data is based on:",
          items: [
            "Your express consent when submitting the contact form",
            "The execution of pre-contractual measures when you request information about our services",
            "Our legitimate interest in responding to business inquiries"
          ]
        },
        retention: {
          title: "Data Retention",
          content: "We retain your personal data for the following periods:",
          items: [
            "If no business relationship is established: 12 months from your last communication",
            "If a business relationship is established: for the duration of the relationship and subsequently for the time necessary to comply with legal obligations (up to 6 years for tax and accounting obligations)"
          ]
        },
        recipients: {
          title: "Recipients and Data Processors",
          content: "To manage your data and respond to your inquiries, we use the following service providers acting as data processors:",
          items: [
            "Resend: email service provider for sending communications",
            "Emergent: web hosting and hosting platform",
            "MongoDB: database for secure record storage"
          ],
          note: "These providers only process your data following our instructions and in accordance with their respective privacy policies."
        },
        transfers: {
          title: "International Transfers",
          content: "Some of our service providers may be located outside the European Economic Area. In these cases, we ensure that adequate safeguards exist to protect your data, such as Standard Contractual Clauses approved by the European Commission or adherence to the EU-US Data Privacy Framework."
        },
        rights: {
          title: "Your Rights",
          content: "Under the General Data Protection Regulation (GDPR), you have the right to:",
          items: [
            "Access: know what personal data we process about you",
            "Rectification: correct inaccurate or incomplete data",
            "Erasure: request the deletion of your data when no longer necessary",
            "Object: object to the processing of your data in certain circumstances",
            "Restriction: request restriction of processing in certain cases",
            "Portability: receive your data in a structured, commonly used format",
            "Withdraw consent: at any time, without affecting the lawfulness of prior processing"
          ],
          exercise: "To exercise any of these rights, contact us at: info@edstatecapital.com",
          complaint: "You also have the right to lodge a complaint with the competent supervisory authority: the Comissão Nacional de Proteção de Dados (CNPD) in Portugal."
        },
        security: {
          title: "Security",
          content: "We implement reasonable technical and organizational measures to protect your personal data against unauthorized access, loss, destruction, or alteration. These measures include the use of encrypted connections (HTTPS) and secure information storage."
        },
        changes: {
          title: "Changes to This Policy",
          content: "We may update this Privacy Policy from time to time. Any changes will be posted on this page with the date of last update. We recommend reviewing it periodically."
        },
        contact: {
          title: "Contact",
          content: "If you have any questions about this Privacy Policy or the processing of your personal data, you can contact us at:",
          email: "info@edstatecapital.com"
        }
      }
    },
    terms: {
      title: "Terms & Conditions",
      lastUpdate: "Last updated",
      backButton: "Back",
      sections: {
        intro: {
          title: "Introduction",
          content: "These Terms and Conditions govern access to and use of the website edstatecapital.com (hereinafter, the \"Website\"), operated by Edson Rodrigues. By accessing or using this Website, you accept these terms in full."
        },
        purpose: {
          title: "Purpose of the Website",
          content: "This Website is for informational purposes only. Its objective is to present the real estate investment services offered by EDSTATE Capital and facilitate contact with potential interested investors."
        },
        disclaimer: {
          title: "Disclaimer",
          content: "The information contained on this Website:",
          items: [
            "Does not constitute legal, tax, financial, or investment advice",
            "Should not be considered as an offer or solicitation to purchase any asset or financial service",
            "Is general in nature and may not be suitable for your particular situation"
          ],
          note: "Any investment decision should be evaluated independently and, if necessary, with the advice of qualified professionals. Real estate investments carry risks, including the possible loss of capital."
        },
        liability: {
          title: "Limitation of Liability",
          content: "EDSTATE Capital shall not be liable for:",
          items: [
            "Direct or indirect damages arising from the use or inability to use the Website",
            "Errors or omissions in the Website content",
            "Decisions made based on the information provided on the Website",
            "Interruptions, technical failures, or security issues of the Website",
            "Actions of third parties that may affect the Website or its users"
          ]
        },
        ip: {
          title: "Intellectual Property",
          content: "All content on this Website, including but not limited to text, graphics, logos, images, design, and source code, is the property of EDSTATE Capital or its respective owners and is protected by applicable intellectual property laws.",
          restrictions: "Reproduction, distribution, modification, or commercial use of any Website content without express written authorization is prohibited."
        },
        links: {
          title: "Third-Party Links",
          content: "This Website may contain links to third-party websites. These links are provided solely for your convenience. EDSTATE Capital has no control over the content of these sites and assumes no responsibility for them or for any damage arising from their use."
        },
        modifications: {
          title: "Modifications",
          content: "We reserve the right to modify these Terms and Conditions at any time. Modifications will take effect from their publication on the Website. Continued use of the Website after any modification implies acceptance of the new terms."
        },
        law: {
          title: "Applicable Law and Jurisdiction",
          content: "These Terms and Conditions are governed by Portuguese law. For any dispute arising from the use of the Website, the parties submit to the exclusive jurisdiction of the courts of Portugal, expressly waiving any other jurisdiction that may apply."
        },
        contact: {
          title: "Contact",
          content: "If you have any questions about these Terms and Conditions, you can contact us at:",
          email: "info@edstatecapital.com"
        }
      }
    },
    keepProperty: {
      label: "KEEP OPTION",
      title: "Prefer to keep the property?",
      desc: "If after appreciation you decide to keep the project, the agreed percentage will be applied to the initially projected gain. Transform an investment project into a personal asset, with no surprises, with the peace of mind of having acquired below market value.",
    },
  },
  pt: {
    nav: {
      about: "Sobre Nós",
      services: "Serviços",
      process: "Processo",
      investment: "Investimento",
      contact: "Contacto",
    },
    hero: {
      tagline: "INVESTIMENTO IMOBILIÁRIO EM PORTUGAL",
      title: "O seu parceiro estratégico de investimento na Madeira",
      subtitle: "Acesso prioritário a oportunidades imobiliárias na Madeira, maioritariamente off-market: due diligence, aquisição, obra e saída. Você escolhe o quanto se envolver.",
      cta: "Agendar Reunião",
      ctaSecondary: "Saber Mais",
    },
    about: {
      label: "SOBRE NÓS",
      title: "Mais de 16 anos de experiência no mercado imobiliário da Madeira",
      p1: "A EDSTATE nasceu de algo raro neste setor: relações reais. Clientes que começaram com uma compra guiada hoje são amigos e sócios, e fazem parte da nossa comunidade privada de investidores.",
      p2Bold: "Não somos imobiliária.",
      p2: "Somos uma empresa de investimento, desenvolvimento e gestão estratégica. Identificamos ativos com potencial, estruturamos a operação e executamos com um padrão claro.",
      p3: "O nosso objetivo não é intermediar vendas. É maximizar o potencial real de cada oportunidade junto a investidores que priorizam clareza, proteção de capital e retornos bem desenhados.",
      stat1: "16+",
      stat1Label: "Anos de experiência",
      stat2: "200+",
      stat2Label: "Agentes na rede",
      stat3: "100%",
      stat3Label: "Gestão integral",
    },
    services: {
      label: "SERVIÇOS",
      title: "O que fazemos por si?",
      s1Title: "Busca de Oportunidades Únicas",
      s1Desc: "Detetamos imóveis off-market com sistemas de prospeção e rede local. Vamos direto ao proprietário e negociamos condições para fechar oportunidades com melhor margem.",
      s2Title: "Análise Técnica e Financeira",
      s2Desc: "Clareza total antes de avançar: números de entrada, fiscalidade e intervalos de investimento em reforma. Projeção de valor final e cenários de retorno segundo diferentes saídas.",
      s3Title: "Gestão Operacional Integral",
      s3Desc: "Coordenação completa: arquitetura, engenharia, licenças, supervisão de obras, regularização registral e gestão notarial.",
      s4Title: "Assessoria em Leilões",
      s4Desc: "Avaliação física e legal de imóveis em leilão. Verificação de ónus registrais e inspeção in situ do imóvel.",
    },
    process: {
      label: "PROCESSO",
      title: "Da oportunidade à rentabilidade",
      step1: "Deteção",
      step1Desc: "Acesso a imóveis de alto potencial antes de saírem ao mercado através de prospeção direta e da nossa rede de agentes.",
      step2: "Análise",
      step2Desc: "Estudo completo: documentação, legalidade, histórico registral, ónus e limitações. Avaliação do valor real.",
      step3: "Apresentação",
      step3Desc: "Se a operação cumpre os nossos critérios, é mostrada de forma privada à nossa rede de investidores.",
      step4: "Negociação",
      step4Desc: "Negociação direta com proprietários sem intermediários para conseguir melhores preços de compra.",
      step5: "Execução",
      step5Desc: "Seleção de arquitetos e construtoras. Supervisão completa de obra, qualidade, orçamento e cronograma.",
      step6: "Legalização",
      step6Desc: "Licenças, documentação técnica, alvarás, registo. Tudo em ordem para a venda.",
      step7: "Comercialização",
      step7Desc: "Produção de marketing profissional. Venda através da nossa rede de agentes e portais premium.",
    },
    investment: {
      label: "MODELOS DE INVESTIMENTO",
      title: "Duas formas de investir. Um mesmo padrão.",
      subtitle: "Escolha o nível de participação que melhor se adapta a si. Nós tratamos do resto.",
      model1: "Gestão Integral EDSTATE",
      model1Desc: "Para o investidor que prefere delegar por completo",
      model1Features: [
        "Identificação e análise de oportunidades off-market",
        "Negociação, aquisição e gestão documental completa",
        "Coordenação de obra, supervisão e controlo de qualidade",
        "Estratégia de saída e comercialização profissional",
        "Reporting periódico sem necessidade de acompanhamento ativo"
      ],
      model2: "Gestão Partilhada",
      model2Desc: "Para o investidor que quer participar em decisões chave",
      model2Features: [
        "Acesso às mesmas oportunidades e análise detalhada",
        "Você supervisiona a obra ou escolhe fornecedores de confiança",
        "Nós gerimos a estratégia e a saída",
        "Maior controlo operacional com apoio especializado",
        "Comunicação direta em cada fase do projeto"
      ],
      slider1Label: "Participação do investidor",
      slider1Left: "Mínima",
      slider1Right: "Ativa",
      slider2Label: "Execução EDSTATE",
      slider2Left: "Coordenação",
      slider2Right: "Integral",
      slider3Label: "Tempo necessário",
      slider3Left: "Baixo",
      slider3Right: "Moderado",
      ctaTitle: "Quer conhecer os detalhes exatos?",
      ctaText: "Ao contactar-nos, enviamos um PDF privado com percentagens, estrutura de fees, exemplos reais e cenários de retorno segundo cada modelo.",
      ctaButton: "Solicitar PDF Privado",
      ctaConfidential: "Partilhamos os detalhes em privado para manter clareza e discrição.",
    },
    benefits: {
      label: "BENEFÍCIOS",
      title: "Porquê investir com a EDSTATE?",
      b1: "Acesso a oportunidades reais e maioritariamente inéditas",
      b2: "Custos reduzidos por negociação direta com proprietários",
      b3: "Supervisão total de obras, documentação e processos legais",
      b4: "Ampla rede de comercialização internacional",
      b5: "Transparência, compromisso e foco absoluto na rentabilidade",
      b6: "Comissões reduzidas a 4% (em vez de 5-6%)",
    },
    security: {
      label: "SEGURANÇA LEGAL",
      title: "O seu investimento protegido desde o primeiro momento",
      subtitle: "Cada operação é estruturada para que esteja coberto legal e fiscalmente desde o início.",
      s1Title: "Estrutura Legal do Investidor",
      s1Desc: "Entra com uma posição legal definida e proteção real sobre o seu capital desde o primeiro dia.",
      s2Title: "Acompanhamento Legal",
      s2Desc: "Advogados e notários locais supervisionam cada passo. Cumprimento normativo garantido.",
      s3Title: "Contratos e Responsabilidades",
      s3Desc: "Acordos assinados com papéis, direitos e obrigações claras para todas as partes.",
      s4Title: "Documentação e Transparência",
      s4Desc: "Acesso completo a registos, relatórios e rastreabilidade de cada movimento.",
      checkpoint1: "Estrutura",
      checkpoint2: "Legal",
      checkpoint3: "Contratos",
      checkpoint4: "Documentação",
    },
    contact: {
      label: "CONTACTO",
      title: "Gostaria de fazer parte dos nossos próximos projetos?",
      subtitle: "Contacte-nos para receber as oportunidades atuais e agendar uma reunião privada onde poderemos apresentar as estratégias de investimento, detalhes operativos e projeções de lucro.",
      name: "Nome completo",
      email: "Email",
      phone: "Telefone",
      message: "Mensagem",
      messagePlaceholder: "Conte-nos sobre o seu interesse em investir...",
      submit: "Enviar Mensagem",
      sending: "A enviar...",
      success: "Mensagem enviada! Entraremos em contacto em breve.",
      error: "Erro ao enviar. Por favor, tente novamente.",
      consent: "Li e aceito a",
      consentLink: "Política de Privacidade",
      consentError: "Deve aceitar a Política de Privacidade para continuar.",
    },
    footer: {
      tagline: "O seu parceiro estratégico de investimento imobiliário em Portugal",
      rights: "Todos os direitos reservados",
      privacy: "Privacidade",
      terms: "Termos",
    },
    privacy: {
      title: "Política de Privacidade",
      lastUpdate: "Última atualização",
      backButton: "Voltar",
      sections: {
        intro: {
          title: "Introdução",
          content: "Na EDSTATE Capital, comprometemo-nos a proteger a sua privacidade e os seus dados pessoais. Esta Política de Privacidade explica como recolhemos, utilizamos e protegemos as informações que nos fornece através do nosso site."
        },
        controller: {
          title: "Responsável pelo Tratamento",
          content: "O responsável pelo tratamento dos seus dados pessoais é:",
          name: "Edson Rodrigues",
          location: "Funchal, Madeira, Portugal",
          email: "Email de contacto: info@edstatecapital.com"
        },
        dataCollected: {
          title: "Dados que Recolhemos",
          content: "Apenas recolhemos os dados que nos fornece voluntariamente através do formulário de contacto do nosso site:",
          items: [
            "Nome completo",
            "Endereço de email",
            "Número de telefone (opcional)",
            "Mensagem ou consulta",
            "Idioma de preferência",
            "Data e hora do envio"
          ],
          note: "Não utilizamos cookies de rastreamento, analytics nem ferramentas de tracking de terceiros (como Google Analytics, Meta Pixel ou similares)."
        },
        purpose: {
          title: "Finalidade do Tratamento",
          content: "Utilizamos os seus dados pessoais exclusivamente para:",
          items: [
            "Responder às suas consultas e questões",
            "Coordenar reuniões e chamadas informativas",
            "Fornecer-lhe informações sobre os nossos serviços de investimento imobiliário",
            "Gerir a relação pré-contratual ou contratual se decidir trabalhar connosco"
          ]
        },
        legalBasis: {
          title: "Base Legal",
          content: "O tratamento dos seus dados baseia-se em:",
          items: [
            "O seu consentimento expresso ao enviar o formulário de contacto",
            "A execução de medidas pré-contratuais quando solicita informações sobre os nossos serviços",
            "O nosso interesse legítimo em responder a consultas comerciais"
          ]
        },
        retention: {
          title: "Conservação de Dados",
          content: "Conservamos os seus dados pessoais durante os seguintes períodos:",
          items: [
            "Se não se estabelecer relação comercial: 12 meses desde a sua última comunicação",
            "Se se estabelecer relação comercial: durante a vigência da relação e posteriormente o tempo necessário para cumprir com obrigações legais (até 6 anos para obrigações fiscais e contabilísticas)"
          ]
        },
        recipients: {
          title: "Destinatários e Subcontratantes",
          content: "Para gerir os seus dados e responder às suas consultas, utilizamos os seguintes prestadores de serviços que atuam como subcontratantes:",
          items: [
            "Resend: prestador de serviços de email para o envio de comunicações",
            "Emergent: plataforma de hosting e alojamento web",
            "MongoDB: base de dados para o armazenamento seguro de registos"
          ],
          note: "Estes prestadores apenas tratam os seus dados seguindo as nossas instruções e conforme as suas respetivas políticas de privacidade."
        },
        transfers: {
          title: "Transferências Internacionais",
          content: "Alguns dos nossos prestadores de serviços podem estar localizados fora do Espaço Económico Europeu. Nestes casos, asseguramo-nos de que existam salvaguardas adequadas para proteger os seus dados, como cláusulas contratuais-tipo aprovadas pela Comissão Europeia ou a adesão ao Quadro de Privacidade de Dados UE-EUA."
        },
        rights: {
          title: "Os Seus Direitos",
          content: "Conforme o Regulamento Geral sobre a Proteção de Dados (RGPD), tem direito a:",
          items: [
            "Acesso: conhecer que dados pessoais tratamos sobre si",
            "Retificação: corrigir dados inexatos ou incompletos",
            "Apagamento: solicitar a eliminação dos seus dados quando já não sejam necessários",
            "Oposição: opor-se ao tratamento dos seus dados em determinadas circunstâncias",
            "Limitação: solicitar a limitação do tratamento em certos casos",
            "Portabilidade: receber os seus dados num formato estruturado e de uso comum",
            "Retirar o consentimento: a qualquer momento, sem que isso afete a licitude do tratamento anterior"
          ],
          exercise: "Para exercer qualquer um destes direitos, contacte-nos em: info@edstatecapital.com",
          complaint: "Também tem o direito de apresentar uma reclamação junto da autoridade de controlo competente: a Comissão Nacional de Proteção de Dados (CNPD) em Portugal."
        },
        security: {
          title: "Segurança",
          content: "Implementamos medidas técnicas e organizativas razoáveis para proteger os seus dados pessoais contra o acesso não autorizado, perda, destruição ou alteração. Estas medidas incluem a utilização de ligações encriptadas (HTTPS) e o armazenamento seguro da informação."
        },
        changes: {
          title: "Alterações a esta Política",
          content: "Podemos atualizar esta Política de Privacidade ocasionalmente. Qualquer alteração será publicada nesta página com a data da última atualização. Recomendamos que a reveja periodicamente."
        },
        contact: {
          title: "Contacto",
          content: "Se tiver qualquer questão sobre esta Política de Privacidade ou sobre o tratamento dos seus dados pessoais, pode contactar-nos em:",
          email: "info@edstatecapital.com"
        }
      }
    },
    terms: {
      title: "Termos e Condições",
      lastUpdate: "Última atualização",
      backButton: "Voltar",
      sections: {
        intro: {
          title: "Introdução",
          content: "Estes Termos e Condições regulam o acesso e utilização do site edstatecapital.com (doravante, o \"Site\"), operado por Edson Rodrigues. Ao aceder ou utilizar este Site, aceita estes termos na sua totalidade."
        },
        purpose: {
          title: "Finalidade do Site",
          content: "Este Site tem uma finalidade exclusivamente informativa. O seu objetivo é apresentar os serviços de investimento imobiliário que a EDSTATE Capital oferece e facilitar o contacto com potenciais investidores interessados."
        },
        disclaimer: {
          title: "Isenção de Responsabilidade",
          content: "A informação contida neste Site:",
          items: [
            "Não constitui aconselhamento legal, fiscal, financeiro nem de investimento",
            "Não deve ser considerada como uma oferta ou solicitação de compra de qualquer ativo ou serviço financeiro",
            "É de carácter geral e pode não se adaptar à sua situação particular"
          ],
          note: "Qualquer decisão de investimento deve ser avaliada de forma independente e, se necessário, com o aconselhamento de profissionais qualificados. Os investimentos imobiliários comportam riscos, incluindo a possível perda de capital."
        },
        liability: {
          title: "Limitação de Responsabilidade",
          content: "A EDSTATE Capital não será responsável por:",
          items: [
            "Danos diretos ou indiretos derivados da utilização ou impossibilidade de utilização do Site",
            "Erros ou omissões no conteúdo do Site",
            "Decisões tomadas com base na informação fornecida no Site",
            "Interrupções, falhas técnicas ou problemas de segurança do Site",
            "Ações de terceiros que possam afetar o Site ou os seus utilizadores"
          ]
        },
        ip: {
          title: "Propriedade Intelectual",
          content: "Todos os conteúdos deste Site, incluindo mas não limitado a textos, gráficos, logótipos, imagens, design e código fonte, são propriedade da EDSTATE Capital ou dos seus respetivos titulares e estão protegidos pelas leis de propriedade intelectual aplicáveis.",
          restrictions: "É proibida a reprodução, distribuição, modificação ou uso comercial de qualquer conteúdo do Site sem autorização expressa por escrito."
        },
        links: {
          title: "Links para Terceiros",
          content: "Este Site pode conter links para sites de terceiros. Estes links são fornecidos apenas para sua conveniência. A EDSTATE Capital não tem controlo sobre o conteúdo destes sites e não assume qualquer responsabilidade por eles nem por qualquer dano derivado da sua utilização."
        },
        modifications: {
          title: "Modificações",
          content: "Reservamo-nos o direito de modificar estes Termos e Condições a qualquer momento. As modificações entrarão em vigor a partir da sua publicação no Site. A utilização continuada do Site após qualquer modificação implica a aceitação dos novos termos."
        },
        law: {
          title: "Lei Aplicável e Jurisdição",
          content: "Estes Termos e Condições são regidos pela legislação portuguesa. Para qualquer litígio decorrente da utilização do Site, as partes submetem-se à jurisdição exclusiva dos tribunais de Portugal, renunciando expressamente a qualquer outro foro que lhes possa corresponder."
        },
        contact: {
          title: "Contacto",
          content: "Se tiver qualquer questão sobre estes Termos e Condições, pode contactar-nos em:",
          email: "info@edstatecapital.com"
        }
      }
    },
    keepProperty: {
      label: "OPÇÃO DE CONSERVAR",
      title: "Prefere ficar com o imóvel?",
      desc: "Se após a valorização decidir conservar o projeto, será aplicada a percentagem acordada sobre o ganho projetado inicialmente. Transforme um projeto de investimento num ativo pessoal, sem surpresas, com a tranquilidade de ter adquirido abaixo do valor de mercado.",
    },
  },
};
